class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // The empty-cart state has a more specific off-canvas transform in the theme CSS.
    // Force the loaded drawer panel open at runtime so the overlay and panel stay in sync.
    setTimeout(() => {
      this.classList.add('animate', 'active');
      const inner = this.querySelector('.drawer__inner');
      if (this.classList.contains('is-empty') && inner) {
        inner.style.setProperty('transform', 'translateX(0)', 'important');
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    const inner = this.querySelector('.drawer__inner');
    if (inner) inner.style.removeProperty('transform');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

;(() => {
  if (window.__gfCartChatPosition) return;
  window.__gfCartChatPosition = true;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  let frame = 0;
  let panel;
  let footer;
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const resize = new ResizeObserver(schedule);
  function update() {
    frame = 0;
    const nextPanel = drawer.querySelector('.drawer__inner');
    const nextFooter = drawer.querySelector('.drawer__footer');
    if (panel !== nextPanel || footer !== nextFooter) {
      resize.disconnect();
      panel = nextPanel;
      footer = nextFooter;
      if (panel) resize.observe(panel);
      if (footer) resize.observe(footer);
    }
    let x = 0;
    let y = 0;
    if (drawer.classList.contains('active') && panel) {
      const width = panel.getBoundingClientRect().width;
      if (window.innerWidth - width >= 440) {
        x = Math.ceil(width + 16);
      } else if (!drawer.classList.contains('is-empty') && footer) {
        y = Math.ceil(Math.max(0, window.innerHeight - footer.getBoundingClientRect().top) + 16);
      }
    }
    document.documentElement.style.setProperty('--gf-cart-chat-x', x + 'px');
    document.documentElement.style.setProperty('--gf-cart-chat-y', y + 'px');
  }
  new MutationObserver(schedule).observe(drawer, {attributes: true, attributeFilter: ['class'], childList: true, subtree: true});
  window.addEventListener('resize', schedule, {passive: true});
  schedule();
})();
